import React from "react";
import "../../LandingPage/LandingPage.css";
import { Skeleton } from "../Skeleton/Skeleton";

/**
 * Full-viewport placeholder shown while a lazy route chunk downloads and
 * while a detail page fetches its data.
 *
 * min-height: 100dvh is the point of it: the site footer is rendered as a
 * sibling of the routed content in AppContent, so a short loading screen
 * used to let the footer ride up into view for a beat before the real
 * article rendered and pushed it back down. A full-height placeholder keeps
 * the footer below the fold for the whole load.
 *
 * Shape roughly mirrors the shared sticky-header + hero + title + body
 * layout of PlaceDetailPage / GuideDetailPage so the swap to real content
 * doesn't jump.
 */
const PageSkeleton = () => (
  <div
    className="landing-page"
    style={{ minHeight: "100dvh", background: "var(--color-bg, #f5ead8)" }}
  >
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 40,
        background: "var(--color-bg, #f5ead8)",
        boxShadow: "var(--shadow-sm)",
        padding: "14px 32px",
      }}
    >
      <Skeleton width={132} height={26} radius={8} />
    </div>

    <section
      style={{ maxWidth: 1120, margin: "0 auto", padding: "24px 32px 64px" }}
    >
      {/* Match the real hero's proportions (.sp-place-hero is aspect-ratio
          21/9, capped at 380px full-bleed) rather than a fixed 320px bar —
          a fixed height read as a squished letterbox that then jumped taller
          when the real image loaded. height:auto so aspect-ratio wins. */}
      <Skeleton
        width="100%"
        height="auto"
        radius={12}
        style={{ aspectRatio: "21 / 9", maxHeight: 380 }}
      />

      <div style={{ marginTop: 28, maxWidth: 620 }}>
        <Skeleton
          width={90}
          height={22}
          radius={999}
          style={{ marginBottom: 14 }}
        />
        <Skeleton width="55%" height={34} style={{ marginBottom: 20 }} />
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Skeleton height={15} />
          <Skeleton height={15} />
          <Skeleton height={15} />
          <Skeleton width="72%" height={15} />
        </div>
      </div>
    </section>
  </div>
);

export default PageSkeleton;
